import { render, staticRenderFns } from "./Explanation7.vue?vue&type=template&id=b9b61e3e&scoped=true&lang=pug&"
import script from "./Explanation7.vue?vue&type=script&lang=ts&"
export * from "./Explanation7.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b61e3e",
  null
  
)

export default component.exports